import { history } from 'instantsearch.js/es/lib/routers'
import { RouterProps } from 'instantsearch.js/es/middlewares'
import type { UiState } from 'instantsearch.js'

type RouteParams = {
  q?: string
  address?: string
  aroundLatLng?: string
  aroundRadius?: string
  filters?: Record<string, string[]>
  page?: number
}

const routingFactory = ({
  indexName,
  searchRestrictions,
}: {
  indexName: string
  searchRestrictions: Record<string, string[]>
}): RouterProps<UiState, RouteParams> => ({
  router: history({
    getLocation: () => {
      if (typeof window === 'undefined') {
        return new URL('https://lamacompta.co') as unknown as Location
      }

      return window.location
    },
  }),
  stateMapping: {
    stateToRoute(uiState: UiState) {
      const indexUiState = uiState[indexName]
      const route = {
        page: indexUiState.page,
        q: indexUiState.query,
        address: indexUiState.configure?.explain
          ? indexUiState.configure?.explain[0]
          : undefined,
        aroundLatLng: indexUiState.configure?.aroundLatLng,
        aroundRadius:
          indexUiState.configure?.aroundRadius &&
            indexUiState.configure?.aroundRadius !== 'all'
            ? `${indexUiState.configure.aroundRadius}`
            : undefined,
        filters: indexUiState.refinementList
          ? Object.keys(indexUiState.refinementList).reduce((prev, cur) => {
            if (indexUiState.refinementList && !searchRestrictions[cur]) {
              return {
                ...prev,
                [cur]: indexUiState.refinementList[cur],
              }
            }
            return prev
          }, {})
          : undefined,
      }

      return route
    },
    routeToState(routeState) {
      const uiState: UiState = {
        [indexName]: {
          page: routeState.page,
          query: routeState.q,
          configure: {
            explain: routeState.address ? [routeState.address] : [],
            aroundLatLng: routeState.aroundLatLng,
            aroundRadius: routeState.aroundRadius
              ? parseInt(routeState.aroundRadius, 10)
              : undefined,
          },
        },
      }

      if (Object.keys(searchRestrictions || {}).length > 0) {
        uiState[indexName].refinementList = {
          ...searchRestrictions,
        }
      }

      if (Object.keys(routeState.filters || {}).length > 0) {
        uiState[indexName].refinementList = {
          ...routeState.filters,
        }
      }

      return uiState
    },
  },
})

export default routingFactory
